import { Injectable } from '@angular/core';
import posthog from 'posthog-js';
import { AnalyticsEvents } from './events.types';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
    track<K extends keyof AnalyticsEvents>(event: K, props: AnalyticsEvents[K]): void {
        try {
            posthog.capture(event, props);
        } catch (e) {
            console.error('[Analytics Error]', e);
        }
    }
}
